import {observable, action, computed} from 'mobx';
import {t} from 'shared/core';
import {DomainObject, oneOf} from 'shared/store';
import Employee from '../employees/Employee'
import CompanyDocument from './CompanyDocument';

class AssignmentRule extends DomainObject {
  @observable assigneeType;
  @observable employee;
  @observable companyDocument;
  @observable order;

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      companyDocument: CompanyDocument,
      assigneeType: oneOf(['employee', 'manager', 'specific_employee'])
    });
  }

  @computed get assignee() {
    if (this.assigneeType === 'specific_employee') return this.employee.id;

    return this.assigneeType;
  }

  @computed get name() {
    if (this.assigneeType === 'specific_employee') return this.employee.name;

    return t(`models.company_document.assignment_rules.${this.assigneeType}`);
  }
}

export default AssignmentRule;
